module.exports = __webpack_public_path__ + "h5/img/bs_06.0e293099.jpeg";